import { MARQUEE_ITEMS } from "@/data/content";

export const Marquee = () => {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div data-testid="editorial-marquee" className="overflow-hidden border-y border-white/10 bg-ink2 py-6">
      <div className="animate-marquee flex w-max items-center gap-16 whitespace-nowrap pr-16">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-16">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-16">
                <span className={i % 2 === 0 ? "font-mono text-[11px] uppercase tracking-[0.35em] text-zinc-500" : "font-serif text-xl italic text-zinc-300"}>
                  {item}
                </span>
                <span className="h-1.5 w-1.5 rotate-45 bg-gold/70" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
